import { Stack } from '@mui/material';
import { DashboardDetails } from '../DashboardDetails';
import { DashboardHeaderActions } from '../DashboardHeaderActions';

export const DashboardHeader = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={0.5}
    >
      <DashboardDetails />
      <DashboardHeaderActions />
    </Stack>
  );
};
